import {
  FilterMode,
  SimulationSession_OrderBy,
  SimulationSession,
  SortOrder,
  SimulationSession_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const simulationSessionService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.simulationSessionOne({ id });
    return result.simulationSessionOne as SimulationSession;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: SimulationSession_OrderBy[] | null = null,
    filter: SimulationSession_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: SimulationSession_Filter | undefined;
    if (searchValue !== "") {
      where = {
        entryPipeline: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.simulationSessionListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ entryPipeline: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.simulationSessionListWithOffset
    ) as SimulationSession[];
    return { list, orderBy };
  },
};
